export default __webpack_public_path__ + "static/media/logo.bea5e2de.png";